import { useEffect, useState } from "react";
import { defBreadcrumb, blogBreadcrumb } from "src/data/DataBreadcrumb";
import Layout from "src/components/Layout";
import NextHead from "src/components/Seo/NextHead";
import BreadcrumbComponent from "src/components/UserInterface/BreadcrumbComponent";
import BlogCardSkeleton from "src/components/Blog/BlogCardSkeleton";
import { BlogOtherCategory } from "src/components/Blog/BlogOtherCategory";
import BlogItem from "src/components/Blog/BlogItem";
import { getBlogs, getImageUrl } from "src/utils/magnolia";

const Category = (props) => {
  const { query, breadcrumb } = props;

  const category = query?.taxonomy;

  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const itemsForBreadCrumb = [
    ...blogBreadcrumb,
    {
      page: `${category}`,
      href: `/blog/${category}`,
      to: `/blog/${category}`,
    },
  ];

  const getBlogList = async () => {
    const { data: blogs, status } = await getBlogs({
      params: {
        limit: 1000,
        taxonomy: category,
      },
    });

    if (status === 200) {
      setBlogs(blogs.results);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getBlogList();
  }, []);

  return (
    <Layout>
      <NextHead
        title={`Blog - ${category}`}
        description="Temukan artikel - artikel menarik mengenai keuangan dan gaya hidup di sini. Selalu update setiap minggu."
        url={`/blog/${category}`}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent
        maxWidth="1006px"
        items={category && itemsForBreadCrumb}
      />
      <div className="blog-category-wrapper">
        <div className="blog-category-container">
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <p className="category">{category && category}</p>
            <div className="blog-items-container">
              <div className="blog-items">
                {isLoading ? (
                  <BlogCardSkeleton />
                ) : blogs.length === 0 ? (
                  <p style={{ margin: "0 12px" }}>Belum ada artikel</p>
                ) : (
                  blogs.map((data, key) => {
                    return (
                      <div key={key}>
                        <BlogItem
                          key={data.slug}
                          thumbnail={getImageUrl(data.thumbnail)}
                          title={data.title}
                          excerpt={data.excerpt}
                          slug={data.slug}
                          taxonomy={data.taxonomy.find((t) => t === category)}
                          previousPageTitle={category}
                          previousPageSlug={category}
                        />
                      </div>
                    );
                  })
                )}
              </div>
              <BlogOtherCategory category={category} />
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .blog-category-wrapper {
          display: flex;
          justify-content: center;
        }
        .blog-category-container {
          display: flex;
          width: 100%;
          max-width: 1040px;
        }
        .blog-items {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        .category {
          font-size: 34px;
          margin: 16px;
        }
        .blog-items-container {
          display: flex;
          justify-content: space-between;
        }
        .artikel-populer {
          margin-top: 64px;
        }
        .artikel-populer p {
          margin: 0 0 16px 10px;
          font-weight: bold;
          color: #676767;
          font-size: 17px;
        }
        .kategori-lainnya {
          margin-left: 10px;
        }
        .kategori-lainnya p {
          font-weight: bold;
          color: #676767;
          font-size: 17px;
          margin-top: 0;
        }
        .kategori-lainnya div {
          display: flex;
          flex-direction: column;
        }
        @media only screen and (max-width: 600px) {
          .blog-list-container {
            flex-direction: column;
          }
          .artikel-populer-wrapper {
            margin-left: 16px;
          }
          .blog-category-container {
            flex-direction: column;
          }
          .blog-items-container {
            flex-direction: column;
          }
          .blog-items {
            justify-content: center;
          }
          .category {
            font-size: 24px;
          }
        }
      `}</style>
    </Layout>
  );
};

Category.getInitialProps = async ({ asPath, query }) => {
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + "/blog",
        name: "Blog",
      },
    },
    {
      "@type": "ListItem",
      position: "3",
      item: {
        "@id": process.env.baseUrl + asPath,
        name: query["blog-category"],
      },
    },
  ];

  return {
    asPath,
    breadcrumb,
    query,
  };
};

export default Category;
